import { FC } from 'react';

import VideoMediaUploader, { MediaUploaderProps } from '@zvuk-b2b/react-uikit/ui/VideoMediaUploader';

import { MediaListItemIconsUploader } from '../MediaList/MediaListItemIcons';

import styles from './index.module.scss';
import VideoMediafilePreviewItemContent from '../VideoMediafilePreviewItem/VideoMediafileItemContent';

type ExtendedMediaUploaderProps = Omit<
  MediaUploaderProps,
  'renderer' | 'onPlay' | 'onPause' | 'onResume' | 'progress' | 'onChangeProgress' | 'playingMediafileData' | 'isPaused'
>;

type MediaUploaderWrapperProps = ExtendedMediaUploaderProps & {
  hintText?: string;
  mediaUploaderClassname?: string;
};

const VideoMediaUploaderWrapper: FC<MediaUploaderWrapperProps> = ({
  accept,
  buttonTitle,
  description,
  elementId,
  isLoading,
  items,
  isMediaUploaderVisible,
  multiple,
  hintText,
  onDrop,
  onRemove,
  onRetry,
  mediaUploaderClassname,
}) => (
  <>
    {hintText && <div className={styles.MediaUploaderWrapperHint}>{hintText}</div>}
    <VideoMediaUploader
      elementId={elementId}
      accept={accept}
      items={items}
      isLoading={isLoading}
      buttonTitle={buttonTitle}
      description={description}
      onDrop={onDrop}
      onRemove={onRemove}
      onRetry={onRetry}
      isMediaUploaderVisible={isMediaUploaderVisible}
      multiple={multiple}
      renderer={VideoMediafilePreviewItemContent}
      postfix={MediaListItemIconsUploader}
      className={mediaUploaderClassname}
    />
  </>
);

export default VideoMediaUploaderWrapper;
